import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import { SingleChargingSession } from "../../../features/chargingSession/components/SingleChargingSession";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import SingleClient from "../../../features/clients/components/SingleClient";
import { SingleStation } from "../../../features/stations/components/SingleStation";
import SingleOrganization from "../../../features/organization/components/SingleOrganization";
import CodeBox from "../../../common/components/atom/CodeBox/CodeBox";
import useNavigationApp from "../../../navigation/useNavigationApp";
import { JWayIcon } from "../../../common/assets/JWayIcons";

export const SINGLE_CHARGE_SESSION_MODAL_ID = "single-chse-modal";
export default function SingleChargingSessionPage() {
  const navigate = useNavigationApp();
  return (
    <div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Créer le",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_create_at" />
              ),
            },
            {
              title: "Client",
              TextRender: () => (
                <SingleChargingSession.Info
                  info="cs_client"
                  renderComponent={({ value }) => (
                    <>
                      {value === "" ? (
                        <>
                          <SingleChargingSession.Info info="cs_client_number_phone" />
                        </>
                      ) : (
                        <>
                          <SingleClient.Info
                            info={"client_firstname"}
                            id={value}
                            emptyText="Aucun client"
                          />{" "}
                          <SingleClient.Info
                            info={"client_lastname"}
                            id={value}
                            emptyText=""
                          />
                        </>
                      )}
                    </>
                  )}
                />
              ),
            },
          ]}
        />

        <TextBox
          content={[
            {
              title: "Prix",
              TextRender: () => (
                <>
                  <SingleChargingSession.Info info="cs_price" />
                  <SingleChargingSession.Info info="cs_currency" />
                </>
              ),
            },
            {
              title: "kWh",
              TextRender: () => (
                <>
                  <SingleChargingSession.Info info="cs_nb_kwh" />
                </>
              ),
            },
          ]}
        />
      </div>

      <div
        style={{
          height: "80px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <SingleChargingSession.Info
          info="cs_station"
          renderComponent={({ value }) => (
            <TextBox
              onClick={() => {
                navigate.goToSingleStation(value);
              }}
              content={[
                {
                  title: "Station",
                  TextRender: () => <SingleStation.Name idStation={value} />,
                },
              ]}
            />
          )}
        />

        <SingleChargingSession.Info
          info="cs_organization"
          renderComponent={({ value }) => (
            <TextBox
              onClick={() => {
                navigate.goToSingleOrganization(value);
              }}
              content={[
                {
                  title: "Organisation",
                  TextRender: () => (
                    <SingleOrganization.Name organizationId={value} />
                  ),
                },
              ]}
            />
          )}
        />
      </div>
      <div
        style={{
          height: "80px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <SingleChargingSession.Info
          info="cs_paygo"
          renderComponent={({ value }) => (
            <TextBox
              onClick={() => {
                navigate.goToSinglePayGo(value, { keepURL: false });
              }}
              content={[
                {
                  title: "Paygo code",
                  TextRender: () => (
                    <>
                      <SingleChargingSession.Info
                        info="cs_paygo_code"
                        renderComponent={({ value }) => (
                          <>
                            <CodeBox code={value} />
                          </>
                        )}
                      />
                    </>
                  ),
                },
              ]}
            />
          )}
        />
      </div>

      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Démarrage du chargement",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_start_time" />
              ),
            },
            {
              title: "Fin du chargement",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_end_time" />
              ),
            },
          ]}
        />
      </div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Statut de la transaction",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_hard_transaction_status" />
              ),
            },
            {
              title: "transaction Id",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_hard_paygo_transaction_id" />
              ),
            }

          ]}
        />
      </div>

        <SingleChargingSession.Info
          info="cs_paygo_credit_produced_token"
          renderComponent={({ value }) => (
            <>
            {value !== "" &&
              <div
              style={{
                height: "150px",
                marginBottom: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
            <TextBox

              content={[
                {
                  title: "Paygo code coupon",
                  TextRender: () => (
                    <>
                      <SingleChargingSession.Info
                        info="cs_paygo_credit_produced_token"
                        renderComponent={({ value }) => (
                          <>
                            <CodeBox code={value} />
                          </>
                        )}
                      />
                    </>
                  
                  ),
                },
                {
                  title: "Nb kWh correspondant",
                  TextRender: () => (
                    <>
                      <SingleChargingSession.Info
                        info="cs_paygo_credit_nb_kwh_remaining"
                
                      />
                    </>
                  
                  ),
                },
              ]}
            />
            </div>
          }
          </>
          
          )}
        />
     

      <div style={{ width: "100%" }}>
        <TextBox
          content={[
            {
              title: "Énergie consommmée",
              isDrawable: true,
              LeftIconRender: () => (
                <JWayIcon color="gray" type="chart-in-box" size={14} />
              ),
              TextRender: () => (
                <div
                  style={{
                    width: "95%",
                    marginLeft: "10px",
                    height: "250px",
                  }}
                >
                  <SingleChargingSession.Charts.GenericChart
                    measurand="Energy.Active.Import.Register"
                    unit="kWh"
                    convert={(v) => Number((v * 0.001).toFixed(2))}
                    chartType="line"
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: 30 }} />
      <div style={{ width: "100%" }}>
        <TextBox
          content={[
            {
              title: "Puissance active",
              isDrawable: true,
              LeftIconRender: () => (
                <JWayIcon color="gray" type="chart-in-box" size={14} />
              ),
              TextRender: () => (
                <div
                  style={{
                    width: "95%",
                    marginLeft: "10px",
                    height: "250px",
                  }}
                >
                  <SingleChargingSession.Charts.GenericChart
                    measurand="Power.Active.Import"
                    chartType="line"
                    label="Puissance active kW"
                    unit="kW"
                    convert={(v) => Number((v * 0.001).toFixed(2))}
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: 30 }} />

      <div style={{ width: "100%" }}>
        <TextBox
          content={[
            {
              title: "Facteur de puissance",
              isDrawable: true,
              LeftIconRender: () => (
                <JWayIcon color="gray" type="chart-in-box" size={14} />
              ),
              TextRender: () => (
                <div
                  style={{
                    width: "95%",
                    marginLeft: "10px",
                    height: "250px",
                  }}
                >
                  <SingleChargingSession.Charts.GenericChart
                    measurand="Power.Factor"
                    chartType="line"
                    label="Facteur de puissance"
                    unit="W"
                    convert={(v) => Number((v * 0.001).toFixed(2))}
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: 30 }} />
      <div style={{ width: "100%" }}>
        <TextBox
          content={[
            {
              title: "Courant",
              isDrawable: true,
              LeftIconRender: () => (
                <JWayIcon color="gray" type="chart-in-box" size={14} />
              ),
              TextRender: () => (
                <div
                  style={{
                    width: "95%",
                    marginLeft: "10px",
                    height: "250px",
                  }}
                >
                  <SingleChargingSession.Charts.GenericChart
                    measurand="Current.Import"
                    chartType="line"
                    label="Courant (A)"
                    unit="A"
                    convert={(v) => Number(v.toFixed(2))}
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: 30 }} />
      <div style={{ width: "100%" }}>
        <TextBox
          content={[
            {
              title: "Température",
              isDrawable: true,
              LeftIconRender: () => (
                <JWayIcon color="gray" type="chart-in-box" size={14} />
              ),
              TextRender: () => (
                <div
                  style={{
                    width: "95%",
                    marginLeft: "10px",
                    height: "250px",
                  }}
                >
                  <SingleChargingSession.Charts.GenericChart
                    measurand="Temperature"
                    chartType="line"
                    label="Température C"
                    unit="C"
                    convert={(v) => Number(v.toFixed(2))}
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
      <div style={{ height: 200 }} />
    </div>
  );
}

export const SingleChargingSessionPageDrawer = ({
  modalId,
}: {
  modalId?: string;
}) => {
  const modalIdFound = modalId || SINGLE_CHARGE_SESSION_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue(["transactionId", modalIdFound]);
  };

  return (
    <>
      <ModalDrawer
        urlParamName={modalIdFound}
        title={"Rechargement"}
        onClose={onClose}
      >
        <SingleChargingSessionPage />
      </ModalDrawer>
    </>
  );
};
